import { FC, useEffect } from 'react';
import { useUsersSearch } from '../hooks';
import { InputSearch } from '@repo/atomic-components';

export const UsersSearchTextControl: FC = () => {
  const { searchInputRef, handleResetClick, handleSearchInputKeyDown } = useUsersSearch();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'f') {
        event.preventDefault();
        if (searchInputRef.current) {
          searchInputRef.current.focus();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex w-full flex-row gap-2">
      <InputSearch
        ref={searchInputRef}
        type="text"
        placeholder="Search by name"
        onKeyDown={handleSearchInputKeyDown}
        onClear={handleResetClick}
        isLoading={false}
      />
    </div>
  );
};
